import React, { useState, useEffect } from "react";
import logoPixiBanner from "../../assets/dixi_ponto_banner.png";
import logoEvoBanner from "../../assets/logo_evo.png";
import logoTecnoBanner from "../../assets/logo-tecno.png";
import { useThemeController } from "../../hooks/ThemeHooks";
import "./Logo.css"; 

const Logo = ({ 
  classeCustom
}) => {
  const { temaAtual, TEMAS } = useThemeController();
  const [logoAtual, setLogoAtual] = useState(logoPixiBanner);

  useEffect(() => {
    if (temaAtual === TEMAS.EVO) {
      setLogoAtual(logoEvoBanner);
    } else if (temaAtual === TEMAS.TECNOPONTO) {
      setLogoAtual(logoTecnoBanner);
    } else {
      setLogoAtual(logoPixiBanner);
    }
  }, [temaAtual, TEMAS.EVO, TEMAS.TECNOPONTO]);

  return (
    <div className={"logo-container"}>
      <img
        key={`logo-banner-${temaAtual}`}
        className={`
        logo
        ${classeCustom || ""}
      `}
        src={logoAtual}
        alt="Logo"
      />
    </div>
  );
};

export default Logo;
